import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Box, Card, Link, Container, Typography,Stack,Button } from '@material-ui/core';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Icon } from '@iconify/react';

import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { ResetPassword } from '../components/authentication/resetPassword';
import CommonPageHeader from '../components/CommonPageModules/CommonPageHeader';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Register() {
  return (
    <Page title="User |  FAPS">
      <Container>
       
       <CommonPageHeader path="/dashboard/user" btname="Back" pageName="Reset password"/>

          <ResetPassword />

      
      </Container>
    </Page>
  );
}
